import { ReactNode } from "react";

import DocumentationIconButton from "components/DocumentationIconButton";
import PageWrapper from "components/PageWrapper";
import { getDocsUrl } from "utils/getDocsUrl";
import PageInfoHeader from "ds/components/PageInfoHeader";

type AiPageLayoutProps = {
  children: ReactNode;
};

const AiPageLayout = ({ children }: AiPageLayoutProps) => {
  return (
    <>
      <PageInfoHeader title="Spacelift Intelligence">
        <DocumentationIconButton
          href={getDocsUrl("/concepts/run/ai")}
          tooltipText="Go to AI documentation"
        />
      </PageInfoHeader>
      <PageWrapper>{children}</PageWrapper>
    </>
  );
};

export default AiPageLayout;
